import { Bike } from '../../models/bike';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BikeService } from '../../services/bike.service';

@Component({
  selector: 'app-bikes-delete',
  templateUrl: './bikes-delete.component.html',
  styleUrls: ['./bikes-delete.component.css']
})
export class BikesDeleteComponent implements OnInit {

  bike : Bike;
  @Output() onDeleteValidation = new EventEmitter<boolean>();

  constructor(private service : BikeService,
              public activeModal : NgbActiveModal) { }

  ngOnInit() {
  }

  onDeleteClick(deleteLock : boolean) {
    this.service.delete(this.bike, deleteLock).subscribe(() => {
      this.activeModal.close("close");
      this.onDeleteValidation.emit(true);
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/bikes/bikes-delete/bikes-delete.component.ts